import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Profile.scss";

import { FaLightbulb, FaTrash } from "react-icons/fa";
import { GiCrown } from "react-icons/gi";
import { MdOutlineWorkspacePremium, MdLogout, MdHistory } from "react-icons/md";
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoBriefcaseOutline } from "react-icons/io5";
import { AiOutlineEdit } from "react-icons/ai";
import { IoCameraSharp } from "react-icons/io5";
import { IoIosArrowBack, IoMdCloseCircle } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { TfiReload } from "react-icons/tfi";
import { GoShieldCheck } from "react-icons/go";

import { useDispatch, useSelector } from "react-redux";
import {
  clearUser,
  updateOpenSupport,
  updateUser,
  updateUserToken,
} from "../../redux/features/user-slice";
import { clearOrganization } from "../../redux/features/organization-slice";
import { clearBranches } from "../../redux/features/branch-slice";
import { clearCart } from "../../redux/features/cart-slice";
import {
  deleteMyAccount,
  logoutUser,
  updateMyAccount,
  updateMyPassword,
} from "../../api/auth";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";
import { useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import { toast } from "react-toastify";
import InputField from "../../components/InputField/InputField";
import Home from "../Home/Home";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import { format } from "date-fns";
import {
  deleteOrganizationSubscriptionInvoice,
  fetchOrganizationSubscriptionInvoices,
} from "../../api/subscription";
import { Capacitor } from "@capacitor/core";
import { clearAnalytics } from "../../redux/features/analytics-slice";
import { clearHomeData } from "../../redux/features/home-slice";
import { clearSubscriptionPlans } from "../../redux/features/subscription-slice";
import ConfirmAdminDelete from "../../components/ConfirmAdminDelete/ConfirmAdminDelete";
import { clearProducts } from "../../redux/features/products-slice";
import { storage } from "../../helpers/storage";
import { clearCustomers } from "../../redux/features/customers-slice";
import { clearOrders } from "../../redux/features/orders-slice";
import { clearSales } from "../../redux/features/sales-slice";

import ReactDOM from "react-dom";

import Cropper from "react-easy-crop";
import imageCompression from "browser-image-compression";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const Profile = () => {
  const { currentViewPort } = useViewPortDetector();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.userReducer.value);
  const organization = useSelector((state) => state.organizationReducer.value);

  const [selectedTag, setSelectedTag] = useState("");
  const [openAdminDelete, setOpenAdminDelete] = useState(false);

  const handleLogOut = () => {
    logoutUser(user?.token)
      .then((res) => {})
      .catch((err) => {});
    dispatch(clearUser());
    dispatch(clearProducts());
    dispatch(clearAnalytics());
    dispatch(clearBranches());
    dispatch(clearCart());
    dispatch(clearHomeData());
    dispatch(clearOrganization());
    dispatch(clearSubscriptionPlans());
    dispatch(clearSales());
    dispatch(clearOrders());
    dispatch(clearCustomers());
    storage.removeAll();
  };

  const handleOpenSupport = () => {
    dispatch(updateOpenSupport({ open_support: "support" }));
  };

  return (
    <>
      <div className="page-with-side-components">
        {currentViewPort === "desktop" && (
          <div className="profile-page-home-container">
            <div className="desktop-navbar box-shadow">
              <p>{ROUTES.profile.title}</p>
            </div>
            <Home profile={true} />
          </div>
        )}
        <div className="right-desktop-view profile-page relative">
          <div className="desktop-navbar box-shadow">
            <p>Profile</p>
          </div>
          <div className="user-profile-page">
            <div className="user-profile-container">
              <div className="cover-image">
                <img
                  src={
                    user?.cover_image
                      ? `${IMAGE_URL}${user?.cover_image}`
                      : "/images/default-cover.svg"
                  }
                  alt=""
                  aria-label={
                    user?.cover_image
                      ? `${user?.name || "User"}'s Cover Image`
                      : "User's Default Cover Image"
                  }
                />
              </div>
              <div className="profile-details">
                <div className="image">
                  <span></span>
                  <img
                    src={
                      user?.image
                        ? `${IMAGE_URL}${user?.image}`
                        : "/images/profile.svg"
                    }
                    alt=""
                    aria-label={
                      user?.image
                        ? `${user?.name || "User"}'s Profile Image`
                        : "User's Default Profile Image"
                    }
                  />
                </div>

                <div className="info">
                  <p className="name">
                    {user?.name || "User Name"}{" "}
                    <span>
                      {organization?.subscription?.plan?.product?.name ===
                      "Pro" ? (
                        <GiCrown />
                      ) : organization?.subscription?.plan?.product?.name ===
                        "Plus" ? (
                        <MdOutlineWorkspacePremium />
                      ) : (
                        <FaLightbulb />
                      )}
                    </span>
                  </p>

                  <div className="credentials">
                    <p className="email">{user?.email || "Email"}</p>
                  </div>
                </div>
              </div>

              <div className="user-profile-options">
                <div
                  className="item"
                  onClick={() => {
                    setSelectedTag("Edit Profile");
                  }}
                >
                  <AiOutlineEdit />
                  <p>Edit Profile</p>
                </div>
                {user?.id && !user?.is_admin ? (
                  <div
                    className="item"
                    onClick={() => {
                      setSelectedTag("My Permissions");
                    }}
                  >
                    <GoShieldCheck />
                    <p>My Permissions</p>
                  </div>
                ) : (
                  <></>
                )}
                {/* <div
                  className="item"
                  onClick={() => {
                    setSelectedTag("Business Information");
                  }}
                >
                  <IoBriefcaseOutline />
                  <p>Business Information</p>
                </div> */}
                <div
                  className="item"
                  onClick={() => {
                    setSelectedTag("Subscription History");
                  }}
                >
                  <MdHistory />
                  <p>Subscription History</p>
                </div>
                <div
                  className="item"
                  onClick={() => {
                    if (currentViewPort === "desktop") {
                      handleOpenSupport();
                    } else {
                      navigate(ROUTES.support.path, {
                        state: { profile: true },
                      });
                    }
                  }}
                >
                  <FaRegQuestionCircle />
                  <p>Support</p>
                </div>
                <div
                  className="item danger"
                  onClick={() => {
                    setSelectedTag("logout");
                  }}
                >
                  <MdLogout />
                  <p>Log Out</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedTag && (
        <div
          className="blur-back"
          onClick={() => {
            setSelectedTag(null);
          }}
        ></div>
      )}

      <EditProfile
        open={selectedTag}
        setOpen={setSelectedTag}
        user={user}
        setOpenAdminDelete={setOpenAdminDelete}
      />
      <MyPermissions open={selectedTag} setOpen={setSelectedTag} user={user} />
      <LogoutModel open={selectedTag} setOpen={setSelectedTag} user={user} />
      <SubscriptionDetails open={selectedTag} setOpen={setSelectedTag} />
      <ConfirmAdminDelete
        open={openAdminDelete}
        setOpen={setOpenAdminDelete}
        handleComplete={handleLogOut}
        user={user}
      />
    </>
  );
};

export default Profile;

const MyPermissions = ({ open, setOpen, user }) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open === "My Permissions") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`my-permissions-model ${isVisible ? "active" : ""}`}>
      <div className="top">
        <div
          className="back"
          onClick={() => {
            setOpen(null);
          }}
        >
          <IoIosArrowBack />
        </div>
        <p>My Permissions</p>
      </div>

      {user?.permissions?.length > 0 ? (
        <div className="permission-list">
          {user?.permissions?.map((el, i) => {
            return (
              <div className="item" key={i}>
                <p>{el?.name}</p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="empty">
          <p>No Permissions set for your account.</p>
        </div>
      )}
    </div>
  );
};

const SubscriptionDetails = ({ open, setOpen }) => {
  const [loading, setLoading] = useState(false);

  const [subsDetails, setSubDetails] = useState([]);
  const [selectedSubs, setSelectedSubs] = useState(null);

  const getSubscriptionDetails = () => {
    setLoading(true);
    fetchOrganizationSubscriptionInvoices()
      .then((res) => {
        if (res.data?.subsDetails?.length > 0) {
          setSubDetails(res.data?.subsDetails);
        } else {
          setSubDetails([]);
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSubscriptionDetails();
  }, []);

  const handleRemoveSubs = (id) => {
    setSubDetails((pre) => {
      return pre?.filter((el) => el?.id !== id);
    });
    setSelectedSubs(null);
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open === "Subscription History") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <>
      <div
        className={`subscription-details-model ${isVisible ? "active" : ""}`}
      >
        <div className="top">
          <div
            className="back"
            onClick={() => {
              setOpen(null);
            }}
          >
            <IoIosArrowBack />
          </div>
          <p>Subscription History</p>
        </div>

        {loading ? (
          <div className="subs-loading">
            <TfiReload />
          </div>
        ) : subsDetails?.length > 0 ? (
          <div className="subs-list">
            {subsDetails?.map((el, i) => {
              return (
                <div className="sub-detail-item" key={i}>
                  <p className="date">
                    {el?.created_at
                      ? format(new Date(el?.created_at), "dd MMM yyyy hh:mm a")
                      : "INVALID DATE"}
                  </p>

                  <div
                    className="item-container"
                    onClick={() => {
                      setSelectedSubs(el);
                    }}
                  >
                    <div className="plan-svg">
                      {el?.plan?.name === "Pro" ? (
                        <GiCrown />
                      ) : el?.plan?.name === "Plus" ? (
                        <MdOutlineWorkspacePremium />
                      ) : (
                        <FaLightbulb />
                      )}
                    </div>
                    <div className="mid">
                      <p>
                        Subscribed to <span>{el?.plan?.name}</span>
                      </p>
                      <p className="duration">
                        {el?.billing_cycle === "yearly" ? "1 year" : "1 month"}
                      </p>
                    </div>
                    <p className="price">$ {el?.amount}</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="subs-loading">
            <p>No subscription details found for your organization.</p>
          </div>
        )}
        {selectedSubs && (
          <div
            className="blur-back"
            onClick={() => {
              setSelectedSubs(null);
            }}
          ></div>
        )}
        <SingleSubsDetails
          open={selectedSubs}
          setOpen={setSelectedSubs}
          handleRemoveSubs={handleRemoveSubs}
        />
      </div>
    </>
  );
};

const SingleSubsDetails = ({ open, setOpen, handleRemoveSubs }) => {
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    if (!open) {
      setOpenDelete(false);
    }
  }, [open]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`single-subs-model ${isVisible ? "active" : ""}`}>
        <div className="top-bar">
          <p>Transaction Details</p>
        </div>
        <div className="item-container">
          <div className="plan-svg">
            {open?.plan?.name === "Pro" ? (
              <GiCrown />
            ) : open?.plan?.name === "Plus" ? (
              <MdOutlineWorkspacePremium />
            ) : (
              <FaLightbulb />
            )}
          </div>
          <div className="mid">
            <p>
              Subscribed to <span>{open?.plan?.name}</span>
            </p>
            <p className="duration">
              {open?.billing_cycle === "yearly" ? "1 year" : "1 month"}
            </p>
          </div>
          <p className="price">$ {open?.amount}</p>
        </div>

        <div className="detail-item">
          <p>Purchased Date</p>
          <p className="value">
            {open?.created_at
              ? format(new Date(open?.created_at), "dd MMM yyyy hh:mm a")
              : "INVALID DATE"}
          </p>
        </div>
        <div className="detail-item">
          <p>Payment Method</p>
          <p className="value">
            {open?.payment_method} : ${open?.amount}
          </p>
        </div>
        <div className="detail-item">
          <p>Transaction ID</p>
          <p className="value">{open?.invoice_number}</p>
        </div>

        <div className="buttons">
          <button
            className="delete-invoice"
            onClick={() => {
              setOpenDelete(true);
            }}
          >
            <FaTrash />
          </button>
          <CustomButton
            name={"Got It"}
            color={"primary"}
            type={"button"}
            handleSubmit={() => {
              setOpen(null);
            }}
            bigButton={true}
            disabled={false}
          />
        </div>
      </div>

      <ConfrimDeleteSubsInvoice
        open={openDelete}
        setOpen={setOpenDelete}
        selected={open}
        handleRemoveSubs={handleRemoveSubs}
      />
    </>
  );
};

const ConfrimDeleteSubsInvoice = ({
  open,
  setOpen,
  selected,
  handleRemoveSubs,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = () => {
    if (selected?.id) {
      setSubmitting(true);
      deleteOrganizationSubscriptionInvoice(selected?.id)
        .then((res) => {
          if (res.data?.message) {
            toast.dismiss();
            toast.success(res.data?.message);
          } else {
            toast.dismiss();
            toast.success("Deleted successfully.");
          }
          handleRemoveSubs && handleRemoveSubs(selected?.id);
          setOpen(false);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss();
            toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss();
            toast.error("Transaction deletion failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      setOpen(false);
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`confirm-delete-model ${isVisible ? "active" : ""}`}>
        <p className="title">Delete Transaction</p>

        <div className="confirm-container">
          <p>
            Are you sure you want to <span>DELETE</span> this Transaction
            Details?
          </p>
        </div>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              !submitting && setOpen(false);
            }}
            disabled={submitting}
          />

          <CustomButton
            name={"Yes, Delete"}
            color={"primary"}
            type={"button"}
            handleSubmit={handleConfirm}
            disabled={submitting}
            loader={submitting}
          />
        </div>
      </div>

      {open && (
        <div
          className="blur-back-upper"
          onClick={() => {
            !submitting && setOpen(false);
          }}
        ></div>
      )}
    </>
  );
};

const LogoutModel = ({ open, setOpen, user }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const handleLogOut = () => {
    setLoading(true);
    logoutUser(user?.token)
      .then((res) => {})
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
    dispatch(clearUser());
    dispatch(clearProducts());
    dispatch(clearAnalytics());
    dispatch(clearBranches());
    dispatch(clearCart());
    dispatch(clearHomeData());
    dispatch(clearOrganization());
    dispatch(clearSubscriptionPlans());
    dispatch(clearSales());
    dispatch(clearOrders());
    dispatch(clearCustomers());
    storage.removeAll();
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open === "logout") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`logout-model ${isVisible ? "active" : ""}`}>
        <p className="title">Logout</p>
        <p className="desc">
          Are you sure you want to <span>Logout</span>?
        </p>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(null);
            }}
            disabled={loading}
          />

          <CustomButton
            name={"Yes"}
            color={"primary"}
            type={"button"}
            handleSubmit={() => {
              handleLogOut();
              setOpen(null);
            }}
            disabled={loading}
            loader={loading}
          />
        </div>
      </div>
    </>
  );
};

const EditProfile = ({ open, setOpen, user, setOpenAdminDelete }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const [coverImage, setCoverImage] = useState({
    src: null,
    file: null,
  });

  const [image, setImage] = useState({
    src: null,
    file: null,
  });

  const [openDelete, setOpenDelete] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    clearForm();
  }, [user, open]);

  const clearForm = () => {
    reset({
      name: user?.name || "",
      email: user?.email || "",
      phone: user?.phone || "",
    });

    if (user?.cover_image) {
      setCoverImage({
        src: `${IMAGE_URL}${user?.cover_image}`,
        file: null,
      });
    } else {
      setCoverImage({
        src: null,
        file: null,
      });
    }

    if (user?.image) {
      setImage({
        src: `${IMAGE_URL}${user?.image}`,
        file: null,
      });
    } else {
      setImage({
        src: null,
        file: null,
      });
    }
  };

  const imageRef = useRef(null);

  const [cropSrc, setCropSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setCropSrc(url);
    } else {
      setImage({ src: null, file: null });
    }
  };

  const getCroppedImg = (imageSrc, cropPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = cropPixels.width;
        canvas.height = cropPixels.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          cropPixels.x,
          cropPixels.y,
          cropPixels.width,
          cropPixels.height,
          0,
          0,
          cropPixels.width,
          cropPixels.height
        );

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Canvas empty"));
              return;
            }
            blob.name = "cropped.jpeg";
            resolve(blob);
          },
          "image/jpeg",
          1
        );
      };
    });
  };

  const handleCropSave = async () => {
    try {
      const croppedBlob = await getCroppedImg(cropSrc, croppedAreaPixels);

      const compressedFile = await imageCompression(croppedBlob, {
        maxSizeMB: 2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      });

      setImage({
        src: URL.createObjectURL(compressedFile),
        file: compressedFile,
      });

      setCropSrc(null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCoverImageChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      let url = URL.createObjectURL(file);
      setCoverImage({
        src: url,
        file: file,
      });
    } else {
      setCoverImage({ src: null, file: null });
    }
  };

  const handleEditProfile = (data) => {
    if (!openChangePassword && !openDelete) {
      const userData = new FormData();

      userData.append("name", data?.name);
      userData.append("email", data?.email);
      userData.append("phone", data?.phone);

      if (coverImage.file) {
        userData.append("cover_image", coverImage.file);
      } else if (!coverImage.src) {
        userData.append("cover_image_remove", true);
      }

      if (image.file) {
        userData.append("image", image.file);
      } else if (!image.src) {
        userData.append("image_remove", true);
      }

      if (
        user?.name !== data?.name ||
        user?.email !== data?.email ||
        (user?.phone || "") !== data?.phone ||
        coverImage.file ||
        image.file ||
        (user?.image && !image.src) ||
        (user?.cover_image && !coverImage.src)
      ) {
        setSubmitting(true);
        updateMyAccount(userData)
          .then((res) => {
            storage.set("userData", JSON.stringify(res.data));
            dispatch(updateUser(res.data));
            toast.dismiss();
            toast.success("Account updated successfully.");
            setOpen("");
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                if (err?.response?.data?.errors) {
                  if (err?.response?.data?.errors?.name) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.name}`);
                  } else if (err?.response?.data?.errors?.email) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.email}`);
                  } else {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.message}`);
                  }
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              }
            } else {
              toast.dismiss();
              toast.error("Account update failed!");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        toast.dismiss();
        toast.info("No changes found.");
      }
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open === "Edit Profile") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <>
      <form
        onSubmit={handleSubmit(handleEditProfile)}
        className={`edit-profile-model ${isVisible ? "active" : ""}`}
      >
        <div className="top">
          <div
            className="back"
            onClick={() => {
              setOpen(null);
            }}
          >
            <IoIosArrowBack />
          </div>
          <p>Edit Profile</p>
        </div>
        <div className="form-container">
          <div className="cover-image">
            <img
              src={
                coverImage?.src
                  ? `${coverImage?.src}`
                  : "/images/default-cover.svg"
              }
              alt=""
              aria-label={
                coverImage?.src
                  ? `${user?.name || "User"}'s Cover Image`
                  : "User's Default Cover Image"
              }
            />
            {coverImage.src && (
              <div
                className="image-remove"
                onClick={() => {
                  setCoverImage({
                    file: null,
                    src: null,
                  });
                }}
              >
                <IoMdCloseCircle />
                <p>Remove Cover Image</p>
              </div>
            )}
            <div className="image-input" onChange={handleCoverImageChange}>
              <input disabled={submitting} type="file" accept="image/*" />
              <IoCameraSharp />
              <p>Edit cover photo</p>
            </div>
          </div>

          <div className="profile-details">
            <div className="image" onChange={handleImageChange}>
              <span></span>
              <img
                src={image.src ? `${image.src}` : "/images/profile.svg"}
                alt=""
                aria-label={
                  image?.src
                    ? `${user?.name || "User"}'s Profile Image`
                    : "User's Default Profile Image"
                }
              />
              {image.src && (
                <div
                  className="image-remove"
                  onClick={() => {
                    setImage({
                      file: null,
                      src: null,
                    });
                  }}
                >
                  <IoMdCloseCircle />
                  <p>Remove Profile Image</p>
                </div>
              )}
              <div className="image-input">
                <input disabled={submitting} type="file" accept="image/*" />
                <IoCameraSharp />
              </div>

              {cropSrc &&
                ReactDOM.createPortal(
                  <div className="cropper-modal">
                    <div className="cropper-modal-wrapper">
                      <div className="cropper-wrapper">
                        <Cropper
                          image={cropSrc}
                          crop={crop}
                          zoom={zoom}
                          aspect={1}
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                      </div>
                      <div className="cropper-actions">
                        <button
                          type="button"
                          className="primary"
                          onClick={handleCropSave}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="danger"
                          onClick={() => {
                            setCropSrc(null);
                            setImage(image);
                            if (imageRef.current) {
                              imageRef.current.value = "";
                            }
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>,
                  document.body
                )}
            </div>

            <div className="info">
              <div className="inputs">
                <p>Name</p>
                <input
                  disabled={submitting}
                  type="text"
                  {...register("name", { required: true })}
                />
                {errors["name"]?.type && (
                  <p className="error">
                    {errors["name"].type === "custom"
                      ? errors["name"].message
                      : errors["name"].type === "required"
                      ? `Name field is required.`
                      : errors["name"]?.message || `Name input is not valid.`}
                  </p>
                )}
              </div>

              <div className="inputs">
                <p>E-mail</p>
                <input
                  disabled={submitting}
                  type="email"
                  {...register("email", { required: true })}
                />
                {errors["email"]?.type && (
                  <p className="error">
                    {errors["email"].type === "custom"
                      ? errors["email"].message
                      : errors["email"].type === "required"
                      ? `Email field is required.`
                      : errors["email"]?.message || `Email input is not valid.`}
                  </p>
                )}
              </div>

              <div className="inputs">
                <p>Phone Number</p>
                <input
                  disabled={submitting}
                  type="text"
                  {...register("phone", {
                    required: false,
                    maxLength: {
                      value: 15,
                      message: "Phone number cannot exceed 15 digits",
                    },
                    pattern: {
                      value: /^[+\d ]*$/,
                      message: "Only numbers, +, and spaces are allowed",
                    },
                  })}
                />
                {errors["phone"]?.type && (
                  <p className="error">
                    {errors["phone"].type === "custom"
                      ? errors["phone"].message
                      : errors["phone"].type === "required"
                      ? `Phone field is required.`
                      : errors["phone"]?.message || `Phone input is not valid.`}
                  </p>
                )}
              </div>

              <div
                className="inputs"
                onClick={() => {
                  !submitting && setOpenChangePassword(true);
                }}
              >
                <p>Password</p>
                <span>*************</span>
              </div>

              <button
                className="inputs primary btn"
                type={submitting ? "button" : "submit"}
              >
                {submitting ? <TfiReload /> : "Save"}
              </button>

              <div
                className="inputs btn"
                onClick={() => {
                  !submitting && setOpenDelete(true);
                }}
              >
                <p>Delete Account</p>
              </div>
            </div>
          </div>
        </div>
        {(openDelete || openChangePassword) && (
          <div
            className="blur-back"
            onClick={() => {
              setOpenDelete(false);
              setOpenChangePassword(false);
            }}
          ></div>
        )}

        <DeleteProfileModel
          open={openDelete}
          setOpen={setOpenDelete}
          user={user}
          setOpenAdminDelete={setOpenAdminDelete}
        />
        <ChangeProfilePassword
          open={openChangePassword}
          setOpen={setOpenChangePassword}
          user={user}
        />
      </form>
    </>
  );
};

const DeleteProfileModel = ({ open, setOpen, user, setOpenAdminDelete }) => {
  const [reason, setReason] = useState({
    tag: 1,
    message: "I am no longer using my account",
  });

  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const dispatch = useDispatch();

  const handleLogOut = () => {
    logoutUser(user?.token)
      .then((res) => {})
      .catch((err) => {});
    dispatch(clearUser());
    dispatch(clearProducts());
    dispatch(clearAnalytics());
    dispatch(clearBranches());
    dispatch(clearCart());
    dispatch(clearHomeData());
    dispatch(clearOrganization());
    dispatch(clearSubscriptionPlans());
    dispatch(clearSales());
    dispatch(clearOrders());
    dispatch(clearCustomers());
    storage.removeAll();
  };

  const handleConfirm = () => {
    setDeleting(true);
    const source = Capacitor.isNativePlatform() ? "mobile" : "web";
    const data = {
      reason: reason.message,
    };

    deleteMyAccount(data, source)
      .then((res) => {
        if (res.data?.otp) {
          setOpenAdminDelete(true);
          toast.dismiss();
          toast.info(
            res.data?.message ||
              "OTP send to admin's email, Please verify it to confirm the account deletion."
          );
        } else {
          toast.dismiss();
          toast.info("Account Deleted!");
          handleLogOut();
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss();
          toast.error(err?.response?.data?.message);
        } else {
          toast.dismiss();
          toast.error("Account deletion failed!");
        }
      })
      .finally(() => {
        setDeleting(false);
      });
  };

  const handleReasonChange = (e) => {
    setReason((pre) => {
      return { ...pre, message: e.target.value };
    });
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`delete-profile-model ${isVisible ? "active" : ""}`}>
        <div className="upper">
          <p className="title">Delete Account</p>
          <p>
            We're really sorry to see you go. Are you sure you want to delete
            your account? Once you confirm, your data will gone.
          </p>
        </div>

        <div className="middle">
          <div
            className={`item ${reason?.tag === 1 ? "active" : ""}`}
            onClick={() => {
              setReason({
                tag: 1,
                message: "I am no longer using my account",
              });
            }}
          >
            <span>
              <FaCheckCircle />
            </span>
            <p>I am no longer using my account</p>
          </div>

          <div
            className={`item ${reason?.tag === 2 ? "active" : ""}`}
            onClick={() => {
              setReason({
                tag: 2,
                message: "The service is too expensive",
              });
            }}
          >
            <span>
              <FaCheckCircle />
            </span>
            <p>The service is too expensive</p>
          </div>

          <div
            className={`item ${reason?.tag === 3 ? "active" : ""}`}
            onClick={() => {
              setReason({
                tag: 3,
                message: "I don't understand how to use",
              });
            }}
          >
            <span>
              <FaCheckCircle />
            </span>
            <p>I don't understand how to use</p>
          </div>

          <div
            className={`item last ${reason?.tag === 4 ? "active" : ""}`}
            onClick={() => {
              setReason({
                tag: 4,
                message: "",
              });
            }}
          >
            <span>
              <FaCheckCircle />
            </span>
            <p>Other</p>
          </div>

          <textarea
            defaultValue={reason?.tag === 4 ? reason?.message : ""}
            disabled={reason?.tag !== 4}
            onChange={handleReasonChange}
          />
        </div>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={false}
          />

          <CustomButton
            name={"Confirm"}
            color={"primary"}
            type={"button"}
            handleSubmit={() => {
              setOpenConfirm(true);
            }}
            disabled={false}
          />
        </div>
      </div>
      {openConfirm && (
        <div
          className="blur-back-upper"
          onClick={() => {
            !deleting && setOpenConfirm(false);
          }}
        ></div>
      )}
      <ConfrimModel
        open={openConfirm}
        setOpen={setOpenConfirm}
        handleConfirm={handleConfirm}
        submitting={deleting}
      />
    </>
  );
};

const ConfrimModel = ({ open, setOpen, handleConfirm, submitting }) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`confirm-delete-model ${isVisible ? "active" : ""}`}>
      <p className="title">Account Delete Confirmation</p>

      <div className="confirm-container">
        <img src="/images/warning.svg" alt="" aria-label="Warning" />
        <p>
          Are you sure you want to <span>DELETE</span> this account? <br />{" "}
          Deleting the account will remove your Information from our Server?
        </p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"gray"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Yes, Delete"}
          color={"danger"}
          type={"button"}
          handleSubmit={handleConfirm}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </div>
  );
};

const ChangeProfilePassword = ({ open, setOpen }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset({
      old_password: "",
      password: "",
      confirmPassword: "",
    });
  }, [open]);

  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);

  const handlePasswordChange = (data) => {
    const userData = {
      old_password: data?.old_password,
      password: data?.password,
      confirmPassword: data?.confirmPassword,
      sign_out: data?.sign_out,
    };

    if (data?.old_password !== data?.password) {
      if (data?.password === data?.confirmPassword) {
        setSubmitting(true);
        updateMyPassword(userData)
          .then((res) => {
            if (res.data?.token) {
              storage.set("authToken", res.data?.token);
              const tokenData = {
                token: res.data.token,
              };
              dispatch(updateUserToken(tokenData));
            }
            toast.dismiss();
            toast.success("Password changed successfully.");
            setOpen(false);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                if (err?.response?.data?.errors) {
                  if (err?.response?.data?.errors?.password) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.password}`);
                  } else {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.message}`);
                  }
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              }
            } else {
              toast.dismiss();
              toast.error("Password change failed!");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        setError("confirmPassword", {
          type: "custom",
          message: "Both password does not match!",
        });
      }
    } else {
      setError("password", {
        type: "custom",
        message: "New Password cannot be same as previous password!",
      });
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`delete-profile-model ${isVisible ? "active" : ""}`}>
      <div className="upper">
        <p className="title">Change Password</p>
      </div>

      <div className="middle gap">
        <InputField
          name={"old_password"}
          type={"password"}
          label={"Old Password"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />

        <InputField
          name={"password"}
          type={"password"}
          label={"New Password"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          constraints={{
            minLength: {
              value: 8,
              message: "Password must be at least 9 characters long",
            },
          }}
        />

        <InputField
          name={"confirmPassword"}
          type={"password"}
          label={"Confirm Password"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          constraints={{
            minLength: {
              value: 8,
              message: "Password must be at least 9 characters long",
            },
          }}
        />

        <div className="remember-me">
          <label>
            <input type="checkbox" {...register("sign_out")} />
            <span class="checkbox-container"></span>
          </label>
          <p className="label">Sign out from other devices</p>
        </div>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Confirm"}
          color={"primary"}
          type={"button"}
          handleSubmit={handleSubmit(handlePasswordChange)}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </div>
  );
};
